import Environment from "./environment.type";

export const environment: Environment = {
    tenantSlug: 'meinebaeckerei',
    sentryEnvironment: 'development',
};
